import './Footer.css';

const Footer = () => {
   return (
      <footer className="landing-page-footer">
         <p>&copy; {new Date().getFullYear()} Freight Ops TMS. All rights reserved.</p>
      </footer>
   );
};

export default Footer;
